import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { SoundState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: SoundState = {
    callSounds: [],
    ivrMenu: [],
};


export const callSound: Module<SoundState, RootState> = {
    state,
    getters,
    actions,
    mutations
};